import { Link } from 'react-router-dom';

import { ResetPasswordForm } from '@/components/forms/auth/ResetPasswordForm';
import { Logo } from '@/components/global/Logo';

export const ResetPassword = ({
  isInternalHostname,
}: {
  isInternalHostname: boolean;
}) => {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-[400px] flex-col justify-center px-4 max-sm:items-center lg:w-1/2">
      <div className="flex">{isInternalHostname && <Logo />}</div>
      <h2 className="as-strong mb-6 mt-10 text-black">Reset your Password?</h2>
      <ResetPasswordForm />
      <div className="my-4 flex items-center">
        <div className="h-[1px] w-full bg-neutral-200" />
        <Link
          to={`/${window.localStorage.getItem('active-org-id')}/auth/sign-in`}
          className="as-body-03 w-full text-center text-muted-foreground underline hover:text-black"
        >
          Sign in
        </Link>
        <div className="h-[1px] w-full bg-neutral-200" />
      </div>
    </div>
  );
};
